import React from "react";
/* eslint-disable */
import {
  Box, Card, Grid, CardContent, Divider, CardHeader,
  TableBody, TableCell, TableContainer, TableHead, TableRow, Table, TableFooter
} from '@material-ui/core';


export default class ComponentToPrint extends React.Component {

  render() {
    const productData = this.props.productList;
    const data = this.props.searchData;

    return (
      <div>
        <div>&nbsp;</div>
        <h3><center><u>Order Reallocation Breakdown Report</u></center></h3>
        <div>&nbsp;</div>
        {/* <h4><left>Group - {data.groupID}</left></h4>
        <h4><left>Fresh Collection Center - {data.operationEntityID}</left></h4>
        <h4><left>Product Category - {data.productCategoryID}</left></h4>
        <h4><left>Product - {data.cropID}</left></h4>
        <h4><left>{data.fromDate} - {data.toDate}</left></h4> */}

        <div>&nbsp;</div>
        <Box minWidth={1050}>
          <TableContainer style={{ marginLeft: '5px' }}>
            <Table aria-label="caption table">
              <TableHead>
                <TableRow>
                  <TableCell align={'left'}>Date</TableCell>
                  <TableCell align={'left'}>SKU Code</TableCell>
                  <TableCell align={'left'}>SKU Description</TableCell>
                  <TableCell align={'left'}>Re-allocated FCC</TableCell>
                  <TableCell align={'right'}>Re-allocated Quantity</TableCell>
                  <TableCell align={'right'}>Accepted Quantity</TableCell>
                  <TableCell align={'right'}>Remaining Quantity</TableCell>
                  <TableCell align={'right'}>Return Quantity</TableCell>                
                </TableRow>
              </TableHead>
              <TableBody>
                {productData.map((data, index) => (
                  <TableRow key={index}>
                     <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {data.createdDate ? new Date(data.createdDate).toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' }) : '-'}
                    </TableCell>
                    <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {data.productCode}
                    </TableCell>
                    <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {data.productName}
                    </TableCell>
                    <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {data.factoryName}
                    </TableCell>
                    <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {data.quantity ? parseFloat(data.quantity).toFixed(2) : '0.00'}
                    </TableCell>
                    <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {data.accepetQuantity ? parseFloat(data.accepetQuantity).toFixed(2) : '0.00'}
                    </TableCell>
                    <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {data.remainingQuantity ? parseFloat(data.remainingQuantity).toFixed(2) : '0.00'}
                    </TableCell>
                    <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {data.returnQuantity ? parseFloat(data.returnQuantity).toFixed(2) : '0.00'}
                    </TableCell>
                   
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </div>

    );
  }
}
